<template>
  <div class="ti-stage">
    <wb-aspect-ratio ratio="3x2">
      <picture>
        <source
          media="(min-width: 1440px)"
          :srcset="$parseSrc($t('i18n.stage.image'))"
        />
        <source
          media="(min-width: 1024px)"
          :srcset="$parseSrc($t('i18n.stage.image_mq4'))"
        />
        <source
          media="(min-width: 768px)"
          :srcset="$parseSrc($t('i18n.stage.image_mq3'))"
        />
        <source
          media="(min-width: 480px)"
          :srcset="$parseSrc($t('i18n.stage.image_mq2'))"
        />
        <img :src="$parseSrc($t('i18n.stage.image_mq1'))" alt="tradein-stage" />
      </picture>
    </wb-aspect-ratio>
    <div class="ti-stage__content">
      <div class="ti-stage__text-wrapper">
        <h2>{{ $t('i18n.stage.headline') }}</h2>
        <ul>
          <template v-for="item in $t('i18n.benefits')">
            <li v-if="item.headline" :key="item.headline">
              <wb-icon name="bds/checkmark-circle/16"></wb-icon>
              <p>{{ item.headline }}</p>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import setup from '../../composables/setup';
const { $parseSrc } = setup();
</script>
<style lang="scss">
.ti-stage {
  display: block;
  position: relative;
  overflow: hidden;

  wb-aspect-ratio[ratio='3x2'] .wb-aspect-ratio__height-controller {
    @include breakpoint-from(mq3) {
      padding-top: calc(1 / 2 * 100%);
    }
    @include breakpoint-from(mq4) {
      padding-top: calc(1 / 4 * 100%);
    }
  }

  &__content {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    color: var(--wb-white);
    @include wb-spacing('padding-bottom', 's');
  }

  &__text-wrapper {
    @include wb-content-width;

    h2 {
      @include wb-type-heading-xl;
      width: 80%;

      @include breakpoint-to(mq1) {
        width: 100%;
        text-align: center;
      }

      @include breakpoint-from(mq3) {
        width: 60%;
      }

      @include breakpoint-from(mq5) {
        width: 50%;
      }
    }

    ul {
      display: flex;
      @include wb-spacing('margin-top', 's');

      @include breakpoint-to(mq1) {
        justify-content: center;
      }

      li {
        display: flex;
        align-items: center;

        wb-icon {
          --size: 20px;
          @include wb-spacing('margin-right', 'xxs');

          @include breakpoint-to(mq1) {
            --size: 12px;
          }
        }

        p {
          @include wb-type-copy;
          @include wb-spacing('margin-right', 'xs');

          @include breakpoint-to(mq1) {
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>
